import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'

// State Official pages
import StateOfficialLogin from '@pages/state-official/Login'
import ChangePassword from '@pages/state-official/ChangePassword'
import AddFirstOfficial from '@pages/state-official/AddFirstOfficial'
import AddSecondOfficial from '@pages/state-official/AddSecondOfficial'
import Dashboard from '@pages/state-official/Dashboard'
import PlayerList from '@pages/state-official/PlayerList'
import AddPlayer from '@pages/state-official/AddPlayer'
import PlayerDetail from '@pages/state-official/PlayerDetail'
import OfficialList from '@pages/state-official/OfficialList'
import AddOfficial from '@pages/state-official/AddOfficial'
import RosterList from '@pages/state-official/RosterList'
import CreateRoster from '@pages/state-official/CreateRoster'
import NotFoundPage from '@pages/common/NotFoundPage'

// Components
import StateOfficialLayout from '@components/state-official/StateOfficialLayout'
import ProtectedRoute from '@components/state-official/ProtectedRoute'
import StatusRouter from '@components/state-official/StatusRouter'

// Hooks
import { useStateOfficialAuth } from '@contexts/AuthContext'

const StateOfficialRoutes = () => {
  const { isAuthenticated, loading } = useStateOfficialAuth()

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner">Loading...</div>
      </div>
    )
  }

  return (
    <Routes>
      {/* Public routes */}
      <Route 
        path="/login" 
        element={
          isAuthenticated ? <Navigate to="/dashboard" replace /> : <StateOfficialLogin />
        } 
      />
      
      {/* Status-based routing */}
      <Route
        path="/setup/*"
        element={
          <ProtectedRoute>
            <StatusRouter>
              <Routes>
                <Route path="/change-password" element={<ChangePassword />} />
                <Route path="/add-first-official" element={<AddFirstOfficial />} />
                <Route path="/add-second-official" element={<AddSecondOfficial />} />
              </Routes>
            </StatusRouter>
          </ProtectedRoute>
        }
      />
      
      {/* Protected routes (require full status) */}
      <Route
        path="/*"
        element={
          <ProtectedRoute requiredStatus={3}>
            <StateOfficialLayout>
              <Routes>
                <Route path="/" element={<Navigate to="/dashboard" replace />} />
                <Route path="/dashboard" element={<Dashboard />} />
                
                {/* Player Management */}
                <Route path="/players" element={<PlayerList />} />
                <Route path="/players/add" element={<AddPlayer />} />
                <Route path="/players/:id" element={<PlayerDetail />} />
                
                {/* Official Management */}
                <Route path="/officials" element={<OfficialList />} />
                <Route path="/officials/add" element={<AddOfficial />} />
                
                {/* Roster Management */}
                <Route path="/rosters" element={<RosterList />} />
                <Route path="/rosters/create" element={<CreateRoster />} />
                
                <Route path="*" element={<NotFoundPage />} />
              </Routes>
            </StateOfficialLayout>
          </ProtectedRoute>
        }
      />
    </Routes>
  )
}

export default StateOfficialRoutes